<div id="main">
  <div id="iswResponse" class="respDiaplay">
    {{ GA_paymentResponse.value | iswError }}
  </div>
  <div id="cardPayment" class="" style="margin-top: -7%">
    <!-- error handling -->
    <!-- <div id="iswResponse" class="respDiaplay">
    {{ GA_paymentResponse.value | iswError }}
  </div> -->
    <!-- pay with card -->
    <div class="form-page card-details show checkout_form">
      <div id="cardNumber-container" class="row checkout_form-row">
        <label for="cardPan">Card Pan</label>
      </div>
      <div class="row checkout_form-row">
        <div
          id="expirationDate-container"
          class="row col checkout_form-row-part"
          style="margin-right: 5px"
        >
          <label for="cardExpiry">Card Expiry</label>
        </div>
        <div id="cvv-container" class="row col checkout_form-row-part">
          <label for="cvv">CVV</label>
        </div>
      </div>

      <div class="row checkout_form-row button-container">
        <button
          type="button"
          id="pay-button"
          class="btn btn-lg btn-block checkout_form-button"
        >
          Pay N{{ paymentDetails.amount }}
        </button>
      </div>
    </div>
    <div class="row checkout_form-row form-page pin">
      <div class="back-control" id="pin-back-button">
        <img src="./back-icon.png" />
        <label>Back</label>
      </div>
      <div id="pin-container">
        <label for="cardPin">Card Pin</label>
      </div>
      <div class="button-container">
        <button
          id="continue-button"
          class="btn btn-lg btn-block checkout_form-button"
        >
          Continue
        </button>
      </div>
    </div>

    <!-- some random cardinal thing and otp -->
    <div class="row form-page checkout_form-row otp">
      <div class="back-control" id="otp-back-button">
        <!-- <img src="./back-icon.png" /> -->
        <label>Back</label>
      </div>
      <div class="form-text">
        Please input the OTP sent to your mobile number
      </div>
      <div id="otp-container"><label>OTP</label></div>
      <div class="button-container">
        <button
          id="validate-button"
          class="btn btn-lg btn-block checkout_form-button"
        >
          Validate
        </button>
      </div>
    </div>
    <div class="form-page cardinal">
      <div class="cardinal-container"></div>
    </div>
  </div>
</div>

<div class="text-center" id="loaderMan">
  <div
    class="spinner-border spinner-border"
    style="width: 5rem; height: 5rem"
    role="status"
  >
    <span class="sr-only">Loading...</span>
  </div>
  <br /><br />
  <p style="color: black">Loading..</p>
</div>

<!-- check payment status when payment is onging -->
<div
  style="
    font-size: 13px;
    text-align: center;
    margin-top: 5%;
    margin-top: 40%;
    margin-bottom: 20%;
  "
  id="isStatusCheck"
>
  <button
    (click)="checkPaymentStatus()"
    type="button"
    id="pay-button"
    style="margin-top: 5%; margin-bottom: -10%"
    class="btn btn-lg btn-block checkout_form-button"
  >
    Check Transaction Status
  </button>
</div>
<!-- card option not available -->

<div
  class="text-center"
  id="noCardOption"
  style="margin-top: 20%; margin-bottom: 30%"
>
  Card payment temporarily unavailable, please use alternative options
</div>
